 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_ONE from '@/components/Chapter_One'
 import CHAPTER_TWO from '@/components/Chapter_Two'
 import CHAPTER_THREE from '@/components/Chapter_Three'
 import CHAPTER_FOUR from '@/components/Chapter_Four'
 import CHAPTER_FIVE from '@/components/Chapter_Five'
 import CHAPTER_SIX from '@/components/Chapter_Six'
 import CHAPTER_SEVEN from '@/components/Chapter_Seven'
 import CHAPTER_EIGHT from '@/components/Chapter_Eight'
 import CHAPTER_NINE from '@/components/Chapter_Nine'
 import EPILOGUE from '@/components/Epilogue'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import ALSO_AVAILABLE_FROM_SHANNON_STACEY from '@/components/Also_available_from_Shannon_Stacey'
 import CARINA_PRESS_ROMANCE_PROMISE from '@/components/Carina_Press_Romance_Promise'
 import MEET_THE_MEN_OF_BOSTON_FIRE from '@/components/Meet_the_Men_of_Boston_Fire'
 import HOLIDAY_ROMANCES from '@/components/Holiday_Romances'
 import WRITING_FOR_CARINA from '@/components/Writing_for_Carina'
 import CARINA_ENEWSLETTER from '@/components/Carina_eNewsletter'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_One",
 			"name" : "Chapter_One",
 			"component" : CHAPTER_ONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js